import {
  lookupRowCalories,
  lookupRowTotals,
  sumScaledTotalsFromFoods,
} from '../../../core/nutrients/dietStructureNutrition';

const kcal = (value) => `${Math.round(value)} kcal`;

/**
 * Calories label + full macros for a meal-slot summary card row.
 *
 * Calorie precedence is unchanged: prefer the foods the UI already shows (they
 * carry optimistic scaled_nutrition) whenever they yield real calories, since a
 * summary lookup can be a stale 0 while the cards already have kcal. Macros
 * come from whichever source answered; `macros` is null when only a calorie
 * figure is known.
 */
export function getRowNutrition(nutritionSummary, mealType, optionNumber, foods) {
  const fromFoods = sumScaledTotalsFromFoods(foods);
  if (fromFoods != null && fromFoods.calories > 0) {
    return { caloriesLabel: kcal(fromFoods.calories), macros: fromFoods };
  }

  const fromSummary = lookupRowTotals(nutritionSummary, mealType, optionNumber);
  if (fromSummary != null) {
    return { caloriesLabel: kcal(fromSummary.calories), macros: fromSummary };
  }

  const calories = lookupRowCalories(nutritionSummary, mealType, optionNumber);
  return {
    caloriesLabel: calories != null ? kcal(calories) : '— kcal',
    // Foods may carry macros with no calories (unmatched unit); keep them.
    macros: fromFoods,
  };
}
